import React, { Component, PropTypes } from 'react'
// import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
// import convert from '../../helpers/convert'
import scroller from '../../helpers/scroller'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
// import { Row, Col } from 'react-flexbox-grid'
// import ReactTooltip from 'react-tooltip'
import { SlideDown } from 'react-slidedown'
// import Flip from 'react-reveal/Flip'
import {
  ContainerDivs,
  ScrollToTop,
  Link,
  LinkIcon,
  DiversityEeoStatement,
  ManagerSjfSurvey,
  CompanyList,
  KpiList,
  // Chart,
  // Grade,
  FundName,
  FundSjfReportCardNav,
  FundIssueCoverageBox,
  FundIssueReportCard,
  FundEngagementGradeBox,
  FundMoreInfoTable,
  // FundShareTakeAction,
  // GetStartedInput,
  IyvScorecard,
  ExclusionsGradeBox,
  ExclusionsStatsBox,
  ExclusionsHoldingList,
  PrepareFundHoldingLists,
  InlineSignup
} from '../../components'
import * as searchActions from 'redux/modules/search'

const Styles = require('./FundSocialJusticeScores.css')

// const GROUP_LABELS_FIELDNAMES = [
//   ['All funds','rank'],
//   ['Groups','group'],
//   ['Categories','peer']
// ]

// const DEFAULT_GROUP_TYPE = 'group'


@CSSModules(Styles, {allowMultiple:true})
class IssueSourceDataDescription extends Component {
  static propTypes = {
    issueId: PropTypes.string.isRequired,
  }
  render() {
    return <div styleName='issue-source-data-description'>
      <div styleName='issue-source-data-description__flex'>
        <div styleName='issue-source-data-description__icon'>
          <LinkIcon faclass='fa-info-circle' nospace />
        </div>
        {
          this.props.issueId==='gef' ?
            <p>
              Gender equality ratings are calculated
              using data from the <Link
                to={config.links.gefScorecard}
                title='Equileap Gender Equality Scorecard'
                xstrong
              >
                Equileap Gender Equality Scorecard
              </Link> from Equileap.
            </p> :
            null
        }
        {
          this.props.issueId==='dei' ?
            <p>
              Diversity disclosure ratings are calculated
              using data from the <Link
                to={config.links.deiScorecard}
                title='Workplace Equity Disclosure Scorecard'
                xstrong
              >
                Workplace Equity Disclosure Scorecard
              </Link> from Whistle Stop Capital and As You Sow.
            </p> :
            null
        }
        {
          this.props.issueId==='rji' ?
            <p>
              Racial justice ratings are calculated
              using data from <Link
                to={config.links.rjiScorecard}
                title="As You Sow's Racial Justice Scorecard"
                xstrong
              >
                As You Sow's Racial Justice Scorecard
              </Link>.
            </p> :
            null
        }
        {
          this.props.issueId==='hrc' ?
            <p>
              LGBTQ+ equity ratings are calculated
              using data from the <Link
                to={config.links.hrcScorecard}
                title='Corporate Equality Index'
                xstrong
              >
                Corporate Equality Index
              </Link> from Human Rights Campaign.
            </p> :
            null
        }
      </div>
      <div styleName='issue-source-data-description__methodology-link'>
        <Link
          to={config.routes.methodology}
          title='Methodology'
          roundbutton
        >Methodology<LinkIcon/></Link>
      </div>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class FundNameLabel extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
  }
  render() {
    return <p styleName='results-panel-fund-name'>
      <span styleName='data-label'>Fund</span> {this.props.name}
    </p>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class FundResultsTabs extends Component {
  static propTypes = {
    sectionId: PropTypes.string,
    clickTabFn: PropTypes.func,
    activeTab: PropTypes.string,
  }
  constructor(props) {
    super(props)
    const sjfConfig = [
      ['Gender Equality', 'gef'],
      ['Diversity Disclosures', 'dei'],
      ['Racial Justice', 'rji'],
      ['LGBTQ+ Equity', 'hrc'],
    ]
    const exclusionsConfig = [
      ['Prisons & Borders', 'pff'],
      ['Military Weapons', 'wff'],
    ]
    const isExclusions = props.sectionId === 'exclusions'
    this.state = {
      config: isExclusions ? exclusionsConfig : sjfConfig,
      label: isExclusions ? 'EXCLUSION' : 'EQUITY & JUSTICE'
    }
  }
  //
  btnOnClick = (e) => {
    this.props.clickTabFn(e[1])
  }
  render() {
    return <div styleName='fund-results-tabs-panel'>
      <ContainerDivs>
        <h2>{this.state.label} RATINGS</h2>
        <div styleName='fund-results-tabs-wrap'>
          {
            this.state.config.map((e, i) => {
              let stlNm = 'fund-results-tabs-cell'
              if (e[1] === this.props.activeTab) {
                stlNm += ' active-tab'
              }
              return <div
                key={'fund-results-tabs-cell-'+i}
                styleName={stlNm}
                onClick={ () => { this.btnOnClick(e) } }
              >
                {e[0]}
              </div>
            })
          }
        </div>
      </ContainerDivs>
    </div>
  }
}


@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error,
    // cart: state.cart.result,
  }),
  searchActions)

@asyncConnect([{
  // need 'deferred' otherwise client navigate is blocked until page is loaded
  deferred: true,
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(
      searchActions.shareClassDetails(
        params.fundId,
        params.investmentVehicleId
      )
    )
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundSocialJusticeScores extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    // cart: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)

    // console.log('constructor')
    let holdingLists = null
    if (props.result && props.result.fund) {
      // console.log('SORTING constructor')
      holdingLists = PrepareFundHoldingLists.process(props.result.fund.holdings, props.result.fund.fundholdings)
    }

    // init state has all slidedown flags false, and grouping at default
    // grouping state is not stored in redux, resets for each fund visit
    this.state = {
      viewStats: false,
      showCriteriaSubscoreA: false,
      showCriteriaSubscoreB: false,
      showCriteriaSubscoreC: false,
      showCriteriaSubscoreD: false,
      viewSubscoreRanks: false,
      // activeGrouping: DEFAULT_GROUP_TYPE,
      groupsLoaded: true,
      loadingTime: 500,
      activeTab: 'gef',
      activeExclusionsTab: 'pff',
      holdingLists
    }
  }

  /**
   * Scroll to top before page loads (prevents loading page scrolled down due
   * to SPA routing weirdness)
   */
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  /**
   * Trigger analytics event on page load
   */
  componentDidMount() {
    const { fundId, investmentVehicleId } = this.props.params
    analytics.event(analytics.eventLoadFund(fundId, investmentVehicleId))
  }


  componentWillReceiveProps(props) {
    // console.log('componentWillReceiveProps')
    let holdingLists = null
    if (props.result && props.result.fund && props.result.shareClass) {
      // console.log('SORTING componentWillReceiveProps')
      holdingLists = PrepareFundHoldingLists.process(props.result.fund.holdings, props.result.fund.fundholdings)
    }
    this.setState({ holdingLists })
  }

  /**
   * Wrapper function to render 'View More Button' and 'Stats panel'.
   * Renders button, and renders stats Slidedown if state.viewStats
   * is true.
   *
   * @param  {Object} shareClass - shareclass object
   * @return {JSX} Wrapper for button and Slidedown
   */
  renderMore = (shareClass) => {
    const label = !this.state.viewStats ? 'View more info' : 'View less'
    const iconClass = this.state.viewStats ? 'fa-angle-up' : 'fa-angle-down'
    return (
      <div styleName='more-stats'>
        <div styleName='view-more-wrapper'>
          <button
            styleName='view-more'
            title={label}
            onClick={
              () => {
                this.setState({ viewStats: !this.state.viewStats })
              }
            }
          >
            {label}
            <LinkIcon faclass={iconClass} />
          </button>
        </div>
        <SlideDown styleName='slide-down'>
          {
            this.state.viewStats ?
              <FundMoreInfoTable shareClass={shareClass}/> :
              null
          }
        </SlideDown>
      </div>
    )
  }


  clickTabFn = (x) => {
    scroller.scrollTo('panel-top', 0)
    this.setState({
      activeTab: x || 'gef'
    })
  }


  clickTab2Fn = (x) => {
    scroller.scrollTo('panel2-top', 0)
    this.setState({
      activeExclusionsTab: x || 'pff'
    })
  }


  /**
   * Main render function
   * @return {JSX} page component
   */
  render() {
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    } else if (
      this.props.result && (
        !this.props.result.fund || !this.props.result.shareClass
      )
    ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const { fund, shareClass, sjfFund }  = this.props.result

    // Attach all grades to sjfFund
    sjfFund.grade_gender_equality = fund.grade_gender_equality
    sjfFund.grade_dei = fund.grade_dei
    sjfFund.grade_rji = fund.grade_rji
    sjfFund.grade_hrc = fund.grade_hrc

    const title = shareClass.fund_legal_name
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const name = format.sanitize(shareClass.fund_legal_name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
    const url = config.domain+urlStart+'/profile/'+urlEnd

    /**
     * This genScoreState logic should be moved to happen only once when the
     * fund object is loaded, rather than within the main render function.
     */

    /**
     * Generate a score state object by calculating normalized and formatted
     * figures for use in rendering functions
     *
     * @param  {Object} nrmlzrs - group divisors to normalize for percentile
     * rankings, from config
     * @param  {Object} fnd - fund object with fund values from api
     * @return {Object} score state object with almost everything needed to
     * create tooltips, render containers, etc.
     */
    const genScoreState = (nrmlzrs, fnd, sjfFnd) => {
      const scores = {}
      const cat = fnd.morningstar_category_name
      const grp = fnd.category_group
      scores.dest = encodeURIComponent(fnd.fund_family_name)

      // "out of" figures
      scores.normAllScored = format.number(nrmlzrs.allScored)
      scores.normGroup = format.number(nrmlzrs.groups[grp])
      scores.normPeer = format.number(nrmlzrs.peers[cat])

      // coverage
      scores.gefCount = format.number(fnd.gef_count)
      scores.gefPercentRated = format.perc(fnd.gef_percent_rated)

      // overall scores
      scores.gefOverallScore = format.gefScore(fnd.gef_score)
      scores.deiOverallScore = format.gefScore(fnd.dei_score)
      scores.rjiOverallScore = format.gefScore(fnd.rji_score)
      scores.hrcOverallScore = format.gefScore(fnd.hrc_score)

      scores.gefUnnormalizedOverallScore = format.number(
        fnd.gef_score, false
      )

      // overall ranks
      scores.gefOverallRank = format.number(
        nrmlzrs.allScored - fnd.gef_rank + 1
      )
      scores.gefOverallPercentileRank = format.gefScore(
        fnd.gef_rank, nrmlzrs.allScored, 0, 1
      )

      // groups
      scores.gefOverallGroupRank = format.number(
        nrmlzrs.groups[grp] - fnd.gef_grp + 1
      )
      scores.gefOverallGroupPercentileRank = format.gefScore(
        fnd.gef_grp, nrmlzrs.groups[grp], 0, 1
      )

      scores.deiOverallGroupPercentileRank = format.number(fnd.dei_grp_norm)
      scores.rjiOverallGroupPercentileRank = format.number(fnd.rji_grp_norm)
      scores.hrcOverallGroupPercentileRank = format.number(fnd.hrc_grp_norm)
      scores.deiOverallGroupRank = format.number(config.deiScoreNormalizers.groups[grp] - sjfFnd.dei_grp + 1)
      scores.rjiOverallGroupRank = format.number(config.rjiScoreNormalizers.groups[grp] - sjfFnd.rji_grp + 1)
      scores.hrcOverallGroupRank = format.number(config.hrcScoreNormalizers.groups[grp] - sjfFnd.hrc_grp + 1)
      scores.deiNormGroup = format.number(config.deiScoreNormalizers.groups[grp])
      scores.rjiNormGroup = format.number(config.rjiScoreNormalizers.groups[grp])
      scores.hrcNormGroup = format.number(config.hrcScoreNormalizers.groups[grp])

      // categories
      scores.gefOverallPeerRank = format.number(
        nrmlzrs.peers[cat] - fnd.gef_peer + 1
      )
      scores.gefOverallPeerPercentileRank = format.gefScore(
        fnd.gef_peer, nrmlzrs.peers[cat], 0, 1
      )

      // letter grade (based on group ranking)
      scores.gefOverallGroupGrade = format.gefGrade(
        format.gefScore(fnd.gef_grp, nrmlzrs.groups[grp], 0, 1, true)
      )

      scores.grade_dei = fnd.grade_dei
      scores.grade_rji = fnd.grade_rji
      scores.grade_hrc = fnd.grade_hrc

      // subscores
      const subscoreLabels = ['A', 'B', 'C', 'D']
      subscoreLabels.forEach((el)=> {
        const lwr = el.toLowerCase()
        // score for subscore, w/ decimal
        scores[`subscore${el}ScoreUnnormalized`] = format.number(
          fnd[`gef_score_${lwr}`], false
        )
        // score for subscore
        scores[`subscore${el}Score`] = format.gefScore(
          fnd[`gef_score_${lwr}`]
        )
        // overall rank for subscore
        scores[`subscore${el}Rank`] = format.number(
          nrmlzrs.allScored - fnd[`gef_rank_${lwr}`] + 1
        )
        // overall percentile rank for subscore
        scores[`subscore${el}PercentileRank`] = format.gefScore(
          fnd[`gef_rank_${lwr}`], nrmlzrs.allScored, 0, 1
        )
        // group rank for subscore
        scores[`subscore${el}GroupRank`] = format.number(
          nrmlzrs.groups[grp] - fnd[`gef_grp_${lwr}`] + 1
        )
        // group percentile rank for subscore
        scores[`subscore${el}GroupPercentileRank`] = format.gefScore(
          fnd[`gef_grp_${lwr}`], nrmlzrs.groups[grp], 0, 1
        )
        // category rank for subscore
        scores[`subscore${el}PeerRank`] = format.number(
          nrmlzrs.peers[cat] - fnd[`gef_peer_${lwr}`] + 1
        )
        // category percentile rank for subscore
        scores[`subscore${el}PeerPercentileRank`] = format.gefScore(
          fnd[`gef_peer_${lwr}`], nrmlzrs.peers[cat], 0, 1
        )
      })

      // show/hide flags
      // scores.isUnranked = format.number(fnd.gef_rank) === '-1000'
      // scores.isUnscored = format.number(fnd.gef_score) === '-1000'

      // grouping labels
      scores.morningstar_category_name = cat
      scores.category_group = grp

      // SRI/USSIF tooltips
      scores.sriTipText = (fnd.socially_responsible_fund === 'true') ?
        'Fund reports a Sustainability Mandate to Morningstar' :
        'No Sustainability Mandate'
      scores.sriTip = format.tooltipHtml(scores.sriTipText)
      scores.ussifTipText = 'Member of The Forum for Sustainable and Responsible Investment'
      scores.ussifTip = format.tooltipHtml(scores.ussifTipText)

      return scores
    }

    // hack in case zero funds from the category are ranked
    if (!config.gefScoreNormalizers.peers[fund.morningstar_category_name]) {
      config.gefScoreNormalizers.peers[fund.morningstar_category_name] = 0
    }

    const gefScoresState = genScoreState(config.gefScoreNormalizers, fund, sjfFund)
    //

    // Flag to display the diversity EEO if a fund has one to display
    const eeoStatement = config.ussifFundsDiversityEeo[fund.fund_id] || false

    //
    return <div>
      {container.helmet(title, '', url)}

      { /* FundName */ }
      <FundName
        shareClass={shareClass}
        pathname={this.props.location.pathname}
      />

      { /* Overall score and rank; subscores; subscore ranks */ }
      <ContainerDivs>
        <FundSjfReportCardNav
          gradeGef={shareClass.grade_gender_equality}
          gradeDei={shareClass.grade_dei}
          gradeRji={shareClass.grade_rji}
          gradeHrc={shareClass.grade_hrc}
          gradePff={shareClass.grade_prison_industrial_complex}
          gradeWff={shareClass.grade_military}
          clickTabFn={this.clickTabFn}
          clickTab2Fn={this.clickTab2Fn}
        />

        <br/>
        <br/>
        <InlineSignup />
        <br/>
        <br/>
        <br/>
        <br/>
        
      </ContainerDivs>

      <div id='panel-top'/>
      <div styleName='fund-results-tabs-panel-wrap'>
        <FundResultsTabs
          clickTabFn={this.clickTabFn}
          activeTab={this.state.activeTab}
        />

        {
          this.state.activeTab === 'gef' ?
            <div>
              <ContainerDivs>
                <div styleName='issue-section-title-wrap'>
                  <div>
                    <h2 styleName={'sjf-section-title-'+this.state.activeTab}>GENDER EQUALITY</h2>
                    <FundNameLabel name={fund.fund_legal_name} />
                  </div>
                  <FundIssueCoverageBox
                    count={fund.gef_count} issueId='gef'
                    percentRated={fund.gef_percent_rated}
                  />
                </div>
                <FundIssueReportCard issueId='gef' fund={fund} sjfFund={sjfFund} />
                {
                  fund.grade_gender_equality === 2.5 ?
                    <FundEngagementGradeBox issueId='gef' /> :
                    null
                }
                <IssueSourceDataDescription issueId='gef' />
              </ContainerDivs>
              <KpiList issueId='gef' fund={fund} />
              <ContainerDivs>
                <CompanyList
                  currency={shareClass.currency}
                  holdingLists={this.state.holdingLists.gef}
                  scoreCode='gef'
                  grade={fund.grade_gender_equality}
                />
              </ContainerDivs>
            </div> :
            null
        }

        {
          this.state.activeTab === 'dei' ?
            <div>
              <ContainerDivs>
                <div styleName='issue-section-title-wrap'>
                  <div>
                    <h2 styleName={'sjf-section-title-'+this.state.activeTab}>DIVERSITY DISCLOSURES</h2>
                    <FundNameLabel name={fund.fund_legal_name} />
                  </div>

                  <FundIssueCoverageBox
                    count={sjfFund.dei_count} issueId='dei'
                    percentRated={sjfFund.dei_percent_rated}
                  />
                </div>
                <FundIssueReportCard issueId='dei' fund={fund} sjfFund={sjfFund} />
                {
                  fund.grade_dei === 2.5 ?
                    <FundEngagementGradeBox issueId='dei' /> :
                    null
                }
                <IssueSourceDataDescription issueId='dei' />
              </ContainerDivs>
              <KpiList issueId='dei' fund={sjfFund} />
              <ContainerDivs>
                <CompanyList
                  currency={shareClass.currency}
                  holdingLists={this.state.holdingLists.dei}
                  scoreCode='dei'
                  grade={fund.grade_dei}
                />
              </ContainerDivs>
            </div> :
            null
        }

        {
          this.state.activeTab === 'rji' ?
            <div>
              <ContainerDivs>
                <div styleName='issue-section-title-wrap'>
                  <div>
                    <h2 styleName={'sjf-section-title-'+this.state.activeTab}>RACIAL JUSTICE</h2>
                    <FundNameLabel name={fund.fund_legal_name} />
                  </div>

                  <FundIssueCoverageBox
                    count={sjfFund.rji_count} issueId='rji'
                    percentRated={sjfFund.rji_percent_rated}
                  />
                </div>
                <FundIssueReportCard issueId='rji' fund={fund} sjfFund={sjfFund} />
                {
                  fund.grade_rji === 2.5 ?
                    <FundEngagementGradeBox issueId='rji' /> :
                    null
                }
                <IssueSourceDataDescription issueId='rji' />
              </ContainerDivs>
              <KpiList issueId='rji' fund={sjfFund} />
              <ContainerDivs>
                <CompanyList
                  currency={shareClass.currency}
                  holdingLists={this.state.holdingLists.rji}
                  scoreCode='rji'
                  grade={fund.grade_rji}
                />
              </ContainerDivs>
            </div> :
            null
        }

        {
          this.state.activeTab === 'hrc' ?
            <div>
              <ContainerDivs>
                <div styleName='issue-section-title-wrap'>
                  <div>
                    <h2 styleName={'sjf-section-title-'+this.state.activeTab}>LGBTQ+ EQUITY</h2>
                    <FundNameLabel name={fund.fund_legal_name} />
                  </div>

                  <FundIssueCoverageBox
                    count={sjfFund.hrc_count} issueId='hrc'
                    percentRated={sjfFund.hrc_percent_rated}
                  />
                </div>
                <FundIssueReportCard issueId='hrc' fund={fund} sjfFund={sjfFund} />
                {
                  fund.grade_hrc === 2.5 ?
                    <FundEngagementGradeBox issueId='hrc' /> :
                    null
                }
                <IssueSourceDataDescription issueId='hrc' />
              </ContainerDivs>
              <KpiList issueId='hrc' fund={sjfFund} />
              <ContainerDivs>
                <CompanyList
                  currency={shareClass.currency}
                  holdingLists={this.state.holdingLists.hrc}
                  scoreCode='hrc'
                  grade={fund.grade_hrc}
                />
              </ContainerDivs>
            </div> :
            null
        }

        <ContainerDivs>

          { /* Link to form, or display manager-submitted info */ }
          <ManagerSjfSurvey fundFamilyName={fund.fund_family_name} />

          { /* Diversity-EEO statement + Company lists */ }
          { /* if the fund has a diversity-EEO statement from US-SIF */
            eeoStatement ?
              <DiversityEeoStatement
                fundId={fund.fund_id}
                shareclassId={shareClass.investment_vehicle_id}
                shareName={shareClass.name}
              /> :
              null
          }


          <br/>
          <br/>
          <br/>
          <br/>

          <ScrollToTop />

        </ContainerDivs>
      </div>

      <div id='panel2-top'/>
      <div styleName='fund-results-tabs-panel-wrap'>
        <FundResultsTabs
          sectionId='exclusions'
          clickTabFn={this.clickTab2Fn}
          activeTab={this.state.activeExclusionsTab}
        />

        <ContainerDivs>
          {
            this.state.activeExclusionsTab === 'pff' ?
              <div>
                <div styleName='issue-section-title-wrap'>
                  <div>
                    <h2 styleName={'sjf-section-title'}>PRISONS & BORDERS</h2>
                    <FundNameLabel name={fund.fund_legal_name} />
                  </div>
                </div>

                <div styleName='exclusions-results'>
                  <div styleName='exclusions-results__flex-wrap'>
                    <ExclusionsStatsBox
                      issueId='pff'
                      fund={fund}
                      shareClass={shareClass}
                    />
                    <ExclusionsGradeBox grade={fund.grade_prison_industrial_complex} issueId='pff' />
                  </div>
                  <ExclusionsHoldingList
                    holdingLists={this.state.holdingLists.pff}
                    issueId='pff'
                  />
                </div>
              </div> :
              null
          }

          {
            this.state.activeExclusionsTab === 'wff' ?
              <div>
                <div styleName='issue-section-title-wrap'>
                  <div>
                    <h2 styleName={'sjf-section-title'}>MILITARY WEAPONS</h2>
                    <FundNameLabel name={fund.fund_legal_name} />
                  </div>
                </div>

                <div styleName='exclusions-results'>
                  <div styleName='exclusions-results__flex-wrap'>
                    <ExclusionsStatsBox
                      issueId='wff'
                      fund={fund}
                      shareClass={shareClass}
                    />
                    <ExclusionsGradeBox grade={fund.grade_military} issueId='wff' />
                  </div>
                  <ExclusionsHoldingList
                    holdingLists={this.state.holdingLists.wff}
                    issueId='wff'
                  />
                </div>
              </div> :
              null
          }

          <ScrollToTop />

          { /* button that shows/hides the "stats" panel */
            this.renderMore(shareClass)
          }

        </ContainerDivs>
      </div>


      { /* IYV "report card" */ }
      <IyvScorecard fund={fund} shareClass={shareClass} />

      { /* Get started panel
      <GetStartedInput /> */ }

      { /* Returns, CTAs
      <FundShareTakeAction fund={fund} shareClass={shareClass} url={url}/> */ }
    </div>
  }
}
